import React, { createContext, useState } from 'react';

export const MenuContext = createContext();

const MenuProvider = ({ children }) => {
    const [visibleMenu, setVisibleMenu] = useState(false);

    return (
        <MenuContext.Provider value={{ visibleMenu, setVisibleMenu }}>
            {children}
        </MenuContext.Provider>
    );
}

export { MenuProvider };

